export default __webpack_public_path__ + "static/cashflow3-38e60bd01159054f4b6988317b2355fc.jpg";